document.addEventListener('DOMContentLoaded', function () {
  const buttons = document.querySelectorAll(
    '.product-form__submit, button[name="add"], form[action*="/cart/add"] button[type="submit"]'
  );

  if (!buttons.length) return;

  const priceEl =
    document.querySelector('.m-price-item--sale') ||
    document.querySelector('.m-price-item--regular');

  const currentPrice = priceEl ? priceEl.textContent.trim() : '';

  buttons.forEach((btn, index) => {
    btn.classList.add('my-custom-atc-btn');

    btn.innerHTML = currentPrice
      ? `🛒 ADD TO CART - <span class="btn-discount-price">${currentPrice}</span>`
      : `🛒 ADD TO CART`;

    if (index === 0 && !document.querySelector('.atc-trust-row')) {
      const trust = document.createElement('div');
      trust.className = 'atc-trust-row';
      trust.innerHTML =
  '<span>🔒 Secure checkout</span><span>↩ Easy returns</span>';
      btn.insertAdjacentElement('afterend', trust);
    }
  });
});